// Calendar (v-date-picker) settings for the Kredit / Yotoqxona shartnoma tarixi panels and their
// payment dialogs. Vuetify's own language is Russian (plugins/vuetify.js), so without a locale the
// month and weekday names came out in Russian on an Uzbek page; weeks start on Monday, as in Uzbekistan.
//
// Uzbek names are spelled out here rather than taken from Intl: Chrome reports "uz" as supported but
// ships no Uzbek date names, so Intl answers "2026 M10" and "Mon".
const UZ_MONTHS = [
  "Yanvar", "Fevral", "Mart", "Aprel", "May", "Iyun",
  "Iyul", "Avgust", "Sentabr", "Oktabr", "Noyabr", "Dekabr",
];
// by Date.getUTCDay(): 0 = Sunday
const UZ_WEEKDAYS = ["Ya", "Du", "Se", "Ch", "Pa", "Ju", "Sh"];

const utc = (y, m, d) => new Date(Date.UTC(y, m - 1, d || 1));
const capitalize = (s) => (s ? s.charAt(0).toUpperCase() + s.slice(1) : s);

export default {
  computed: {
    calendarLocale() {
      return { uz: "uz", ru: "ru", en: "en" }[this.$i18n.locale] || "uz";
    },
  },
  methods: {
    // header above the days: "YYYY-MM" -> "Oktabr 2026"; above the month grid: "YYYY" -> "2026"
    calendarHeader(value) {
      const [y, m] = String(value).split("-").map(Number);
      if (!m) return String(y);
      if (this.calendarLocale === "uz") return `${UZ_MONTHS[m - 1]} ${y}`;
      return capitalize(new Intl.DateTimeFormat(this.calendarLocale, { month: "long", year: "numeric", timeZone: "UTC" }).format(utc(y, m)));
    },
    // weekday column labels: "YYYY-MM-DD" -> "Du"
    calendarWeekday(value) {
      const [y, m, d] = String(value).split("-").map(Number);
      if (this.calendarLocale === "uz") return UZ_WEEKDAYS[utc(y, m, d).getUTCDay()];
      return new Intl.DateTimeFormat(this.calendarLocale, { weekday: "short", timeZone: "UTC" }).format(utc(y, m, d));
    },
    // month grid buttons: "YYYY-MM" -> "Okt"
    calendarMonth(value) {
      const m = Number(String(value).split("-")[1]);
      if (this.calendarLocale === "uz") return UZ_MONTHS[m - 1].slice(0, 3);
      return capitalize(new Intl.DateTimeFormat(this.calendarLocale, { month: "short", timeZone: "UTC" }).format(utc(2000, m)));
    },
  },
};
